// Bridge function to request opening the KRR modal from within the existing app tree
const openJiraKRRModal = (id: string, type:string, onClose, onSave, relationshipId: string) => {
    const event = new CustomEvent('openJiraKRRModal', {
      detail: { id, type, onClose, onSave, relationshipId },
    });
    window.dispatchEvent(event);
  };
  (window as any).openJiraKRRModal = openJiraKRRModal;